import FormResultReplacer from './../../form-result-replacer/js/form-result-replacer.component';

export default class RequestCatalogueComponent extends FormResultReplacer {
}



// WEBPACK FOOTER //
// ./app/components/request-catalogue/js/request-catalogue.component.js